import { useLoyaltyStore } from './LoyaltyStore'

import { useEffect } from 'react'

const useLoyaltyLinkLazy = () => {
  const loyaltyLink = useLoyaltyStore((x) => x.loyaltyLink)
  const getLoyaltyLink = useLoyaltyStore((x) => x.getLoyaltyLink)

  useEffect(() => {
    if (!loyaltyLink) {
      getLoyaltyLink()

      console.log('farts')
    }
  }, [loyaltyLink])

  return loyaltyLink
}

export default useLoyaltyLinkLazy
